import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./AboutASG.css"; 

const images = [
  "images/founders/founder1.jpeg", 
  "images/founders/founder2.jpg", 
];

function AboutASG() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [inView, setInView] = useState(false);
  const aboutasgSectionRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const debounce = (func, wait) => {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    };

    const handleScroll = () => {
      if (aboutasgSectionRef.current) {
        const rect = aboutasgSectionRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          setInView(true);
          timeoutRef.current = setTimeout(() => {
            if (aboutasgSectionRef.current) {
              aboutasgSectionRef.current.classList.add("done");
            }
          }, 2000);
        } else {
          setInView(false);
          if (aboutasgSectionRef.current) {
            aboutasgSectionRef.current.classList.remove("done");
          }
        }
      }
    };

    const debouncedHandleScroll = debounce(handleScroll, 100);

    window.addEventListener("scroll", debouncedHandleScroll);
    return () => {
      window.removeEventListener("scroll", debouncedHandleScroll);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 5000); // Change image every 5 seconds
      return () => clearInterval(interval);
    }, []);

  return (
    <div className="about-asg">
      <section className="section-aboutasg" ref={aboutasgSectionRef}>
      <div className="sectiontop-line"></div>
      <h2 className="sectiontitle">ABOUT ASG</h2>
      <div className="sectionbottom-line"></div>
      </section>
      <div className="main-container">
        <section className="university-section"  >
          <div className="content">
            <h1>Our History</h1>
            <p>
            Formed in 1996, the Actuarial Society of Ghana (ASG) is the local organization
             that trains and regulates actuarial practitioners in Ghana. The Actuarial .
             Society of Ghana (ASG) was first admitted to the International Actuarial 
             Association (IAA) 0n <b>June 05, 1998,</b> as an Associate member with the effort
              of the president at the time, <b>Mr. Eric N.A. Adjei</b> (late), and then 
              Director General of SSNIT. A year later, the Actuarial Society of Ghana
               (ASG) had the opportunity to host the <b><i>First International Professional 
               Meeting of Leaders of the Actuarial Profession in English-speaking 
               Africa</i></b> - at the Accra International Conference Center from 
               <b> September 20-22, 1999.</b> That year will go down in history as the 
               beginning of the mobilization of actuarial practitioners in Ghana. 
               <br />
               <br />
               The ASG finally attained Full Member Association (FMA) 
               status of the IAA in 2018 under the leadership of <b>Stephen Abosi Yeboah</b> at 
               the IAA Council & Committee Meeting in Chicago. 
               <br />
               <br />
               Following the leadership of Mr. Eric N.A. Adjei, the Actuarial Society of Ghana 
               (ASG) has been privileged to be led by seasoned professionals such as:
               <br />
               <br />
               <li>Kwasi Osei ( 2000 – 20XX)</li>
               <li>Dr. Frank Albert Odoom (20XX – 20XX)</li>
               <li>Ernest Amartey-Vondee (20XX – 20XX)</li>
               <li>Stephen Abosi Yeboah (20XX – 2018)</li>
               <li>Neil Nii Akramah Tagoe (2019 – 2024) </li>
               <br />
               <br />
               With strategic partnerships with key stakeholders like the 
               NIC, NPRA, NHIA, GIZ, SSNIT and UNDP through the afore-mentioned leaders 
               the ASG continues to impact the financial service policy direction, 
               support public interest, and train actuarial practitioners in both 
               skills and professional education. For instance, on <b>February 2, 2017, </b> 
                the Actuarial Society of Ghana (ASG) held its 20th Anniversary
                Convention at the British Council Auditorium, Accra - Ghana with the 
                theme “The Role of the Actuary in Economic Development”. The ASG since 
                then organized its annual conference on thematic areas that drives the 
                financial services industry and professional development
            </p>
            <div className={`membership-section animate-up ${inView ? "in-view" : ""}`}
          ref={aboutasgSectionRef}>
              <div 
                className="banner" 
                style={{
                  backgroundImage: `url(${images[currentImageIndex]})`, 
                  maxHeight: window.innerWidth < 1300 ? '30vh' : '60vh', 
                  maxWidth: window.innerWidth < 1300 ? '100%' : '100vw', 
                  backgroundSize: 'cover', 
                  backgroundPosition: 'center 15%', 
                  marginBottom: '20px', 
                  margin: window.innerWidth < 768 ? '20px auto' : '40px auto', 
                  display: 'flex', 
                  justifyContent: 'center'
                }}
              >
              </div>

            </div>       
     </div>
      </section>

      <section className="card-section" style={{marginTop: '10px'}}>
        <Link to='/strategic-plan'>
          <div className="accreditation-card">
          <h2 className="uni-title">Strategic Plan </h2>
          </div>
        </Link>
        <Link>
          <div className="accreditation-card">
          <h2 className="uni-title">ASG Constitution</h2>
          </div>
        </Link>
        <Link to='/working-group'>
          <div className="accreditation-card">
          <h2 className="uni-title">Working Group</h2>
          </div>
        </Link>


    </section>           

      </div>
    </div>
  );
}

export default AboutASG;
